import { motion } from 'framer-motion';
import { Bot, Phone, Globe, Sparkles } from 'lucide-react';

const AIAgents = () => {
  const agents = [
    {
      icon: Phone,
      title: 'AI Call Agent',
      image: 'https://www.brightpattern.com/wp-content/uploads/2026/01/Top-Trends-in-AI-Call-Center-Agents-1024x683.jpg.webp',
      features: ['Automated outbound & inbound calling', 'Lead qualification', 'Appointment booking', 'Follow-ups & reminders']
    },
    {
      icon: Globe,
      title: 'AI Landing Page Agent',
      image: 'https://cdn.dribbble.com/userupload/45356806/file/845dacf7f05a0eea73bc89acfb570a57.png?resize=1024x759&vertical=center',
      features: ['Smart lead capture system', 'Automated responses', 'Dynamic form optimization', 'Conversion tracking integration']
    },
    {
      icon: Sparkles,
      title: 'AI Creative Agent',
      image: 'https://dl-file.cyberlink.com/web/content/b3828/l_best-ai-social-media-post-generator.webp',
      features: ['AI-generated ad creatives', 'Social media content generation', 'Marketing copywriting', 'Automated campaign creatives']
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <Bot className="w-16 h-16 mx-auto mb-6 text-neon-purple" />
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-neon-purple to-neon-blue bg-clip-text text-transparent">
            AI Agents Development
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            We build intelligent AI agents that automate sales, marketing, and customer engagement processes.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 isolate">
          {agents.map((agent, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.2 }}
              className="glass-morphism rounded-2xl overflow-hidden hover:border-neon-purple/50 transition-all">
              {agent.image && (
                <div className="h-48 overflow-hidden">
                  <img src={agent.image} alt={agent.title} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-6">
                <agent.icon className="w-12 h-12 mb-4 text-neon-blue" />
                <h3 className="text-xl font-bold mb-4 text-neon-purple">{agent.title}</h3>
                <ul className="space-y-2">
                  {agent.features.map((feature, j) => (
                    <li key={j} className="text-text-secondary flex items-start gap-2">
                      <span className="text-neon-blue mt-1">▹</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIAgents;

